export default "__VITE_ASSET__708aeca8__"